import React from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import NContainer from "components/NContainer";
import Row from "components/Row";

const Background = styled.div`
  background: #27323e;
  /* display: flex;
  flex-direction: row;
  height: 54px;
  justify-content: flex-end;
  align-items: center;
  margin: 20px;
  position: relative;
  bottom: 0;
  width: -webkit-fill-available;
  padding: 0;
  margin: 0; */
`;
const Submit = styled(Button)`
  && {
    background: #ff953f;
    color: #ffff;
    font-size: 15px;
    height: 40px;
    width: 100%;
    border-radius: 7px;
  }
  &&&:hover {
    background: #ffff;
    color: #ff953f;
  }
  &&&:disabled {
    background: #cccc;
    color: white;
  }
`;

const SubmitRow = styled(Row)`
  @media (max-width: 600px) {
    flex-direction: column;
    padding: 0 24px;
    .checkbox {
      justify-content: center;
      margin-right: 0;
    }
  }
`;

export default function SubmitExam({ submitExam }) {
  const clickRef = React.useRef();
  const [checked, setChecked] = React.useState(false);

  const ChangeChecked = () => {
    setChecked(!checked);
  };

  return (
    <Background>
      <NContainer>
        <SubmitRow justify="flex-end" marginbottom={0}>
          <div
            className="checkbox"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              margin: "10px 0",
              marginRight: "20px"
            }}
          >
            <Checkbox
              checked={checked}
              ref={clickRef}
              style={{
                color: "white"
              }}
              onClick={ChangeChecked}
            />
            <Typography
              onClick={() => clickRef.current.click()}
              variant="h6"
              style={{ color: "white" }}
            >
              I would like to submit my answers
            </Typography>
          </div>
          <div
            style={{
              height: "40px",
              display: "flex",
              flexDirection: "row",
              margin: "10px 0",
              cursor: "not-allowed"
            }}
          >
            <Submit
              variant="contained"
              disabled={!checked}
              onClick={submitExam}
            >
              Submit
            </Submit>
          </div>
        </SubmitRow>
      </NContainer>
    </Background>
  );
}
